export const CurrencyFormatter = 
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });